import { render, staticRenderFns } from "./resetpassword.vue?vue&type=template&id=3d50c440&scoped=true"
import script from "./resetpassword.vue?vue&type=script&lang=js"
export * from "./resetpassword.vue?vue&type=script&lang=js"
import style0 from "./resetpassword.vue?vue&type=style&index=0&id=3d50c440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d50c440",
  null
  
)

export default component.exports